module.exports = __webpack_public_path__ + "img/linkedin_white.acb8abe2.svg";